<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5604 8.25H12.8104V4.5H10.5604V8.25H7.56043V2.25H5.31043V8.25H1.44043V9.75H5.31043V15.75H7.56043V9.75H10.5604V13.5H12.8104V9.75H16.5604V8.25Z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
  const props = defineProps({
    color: {
      type: String,
      default: '#0000FF',
    },
    size: {
      type: Number,
      default: 18,
    },
  })
</script>
